import { useStore } from 'effector-react'
import {
  $exchangerTransfers,
  $totalCountOfExchangerStatistic,
  exchangerTransfersListMounted,
  getExchangerTransfers,
} from './model'
import { ExchangerTransfersRequest } from './types'

export const useExchangerTransfersList = () => {
  const exchangerTransfers = useStore($exchangerTransfers)

  const loading = useStore(getExchangerTransfers.pending)

  const totalCountOfExchangerTransfers = useStore(
    $totalCountOfExchangerStatistic,
  )

  const onChangeExchangerTransfersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: ExchangerTransfersRequest) => {
    exchangerTransfersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  return {
    exchangerTransfers,
    totalCountOfExchangerTransfers,
    loading,
    onChangeExchangerTransfersList,
  }
}
